import logoSvg from '@/assets/images/Group.svg'

export function BrandLogo() {
  return (
    <div className="flex items-center gap-2">
      <img
        src={logoSvg}
        alt="Brand Logo"
        className="w-8 h-8"
        width={32}
        height={32}
      />
    </div>
  )
}
